module.exports = __webpack_public_path__ + "static/media/nosotros05.8d560dc7.jpg";